import ReactDOM from "react-dom";
import React from "react";
import Glossary from "../components/glossary/Glossary";

const init = () => {
  const mountPoint = document.querySelector("#Glossary");

  if (mountPoint) {
    ReactDOM.render(<Glossary />, mountPoint);
  }
};

// Init on initial page load
init();

